import React, { useEffect, useState } from 'react'
import { ChevronLeft } from "react-feather"
import { useParams, useNavigate, Link } from "react-router-dom"

import Button from "@/components/Button"
import Container from "@/components/Container"
import OrderStatus from "@/components/OrderStatus"
import OrderProduct from "@/components/OrderProduct"
import Loader from "@/components/Loader"
import api from '../api'

export default function OrderDetailsPage() {
	const navigate = useNavigate()
	const { id } = useParams()
	const [order, setOrder] = useState(null)
	const [orderStatus, setOrderStatus] = useState(null)

	useEffect(() => {
		(async () => {
			const resp = await api.fetchOrderDetails(id)
			if (resp.status !== "ok") {
				navigate("/404")
			}
			console.log("single order",resp.order);
			setOrder(resp.order)
		})()
	}, [id])

	
	useEffect(() => {
		(async () => {
			const resp = await api.orderStatus(id)
			console.log("order status",resp);
			if (!resp.status) {
				navigate("/404")
			}
			setOrderStatus(resp)
		})()
	}, [id])

	const handleDeleteOrder = async (orderId) => {
		try {
			const resp = await api.deleteOrder(orderId);
			if(resp.status == "ok"){
				navigate("/orders")
				// window.location.reload()
			}
		} catch (err) {
			console.log(err);
		}
		};

	if (!order) {
		return <main className='w-screen h-screen flex justify-center items-center'>
			<Loader color="bg-gray-600" />
		</main>
	}

	return (
		<main className="relative mb-20 px-4">

      {/* BACK BUTTON */}
      <button
        onClick={() => history.back()}
        className="flex items-center text-gray-600 hover:text-black mb-4"
      >
        <ChevronLeft className="mr-1" /> Back
      </button>

      {/* MAIN CONTAINER */}
      <div className="max-w-4xl mx-auto bg-white border border-gray-200 rounded-2xl shadow-md p-6">

        {/* HEADER */}
        <div className="border-b pb-4 mb-6">
          <h1 className="text-2xl font-semibold text-gray-800">
            Order Details
          </h1>
          <p className="text-sm text-gray-500">Order ID: #{id}</p>
        </div>

        {/* STATUS */}
        <section className="mb-6">
          <h2 className="text-lg font-medium text-gray-700 mb-2">Status</h2>
          <div className="p-4 border rounded-lg bg-gray-50">
            <OrderStatus currentStatus={orderStatus?.status} />
          </div>
        </section>

        {/* SHIPPING + CONTACT */}
        <section className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">

          {/* Address */}
          <div>
            <h2 className="text-lg font-medium text-gray-700 mb-2">
              Shipping Address
            </h2>
            <div className="text-sm text-gray-600 space-y-1">
              <p className="font-medium text-gray-800">
                {order.address?.name}
              </p>
              <p>{order.address?.area}, {order.address?.city}</p>
              <p>{order.address?.state}, {order.address?.country}</p>
              <p>{order.address?.pincode}</p>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h2 className="text-lg font-medium text-gray-700 mb-2">
              Contact
            </h2>
            <p className="text-sm text-gray-600">
              <strong>Phone:</strong> {order.address?.phone}
            </p>
          </div>

        </section>

        {/* SHIPMENT DETAILS */}
        {orderStatus && (
          <section className="mb-6">
            <h2 className="text-lg font-medium text-gray-700 mb-2">
              Shipment Details
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-gray-600">

              {orderStatus?.data?.invoice_no && (
                <p><strong>Invoice No:</strong> {orderStatus?.data.invoice_no}</p>
              )}

              {orderStatus?.data?.despatch_mode && (
                <p><strong>Sent By:</strong> {orderStatus?.data.despatch_mode}</p>
              )}

              {orderStatus?.data?.gr_date && (
                <p><strong>Shipping Date:</strong> {orderStatus?.data.gr_date}</p>
              )}

              {orderStatus?.data?.gr_no && (
                <p><strong>Tracking ID:</strong> {orderStatus?.data.gr_no}</p>
              )}

              {orderStatus?.status === "Delivered" && orderStatus?.data?.rec_date && (
                <p><strong>Delivered Date:</strong> {orderStatus?.data.rec_date}</p>
              )}

            </div>
          </section>
        )}

        {/* PRODUCTS */}
        <section className="mb-6">
          <h2 className="text-lg font-medium text-gray-700 mb-4">
            Products
          </h2>

          <div className="flex flex-wrap gap-4 justify-center">
            {order.products?.map((p) => (
              <Link key={p.id} to={`/products/${p.id}`}>
                <div className="w-48 border rounded-xl p-3 shadow-sm hover:shadow-md transition">

                  <img
                    src={p.image}
                    alt={p.title}
                    className="w-full h-32 object-cover rounded-lg mb-2"
                  />

                  <h3 className="text-sm font-medium text-gray-800 line-clamp-2">
                    {p.title}
                  </h3>

                  <p className="text-sm text-gray-500">
                    Qty: {p.quantity}
                  </p>

                  <p className="text-sm font-semibold text-gray-800">
                    ₹{p.price}
                  </p>

                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* FOOTER */}
        <div className="border-t pt-4 flex flex-col sm:flex-row justify-between items-center gap-4">

          <p className="text-xl font-semibold text-gray-800">
            Total: ₹{order.amount}
          </p>

          <button
            onClick={() => handleDeleteOrder(id)}
            className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
          >
            Cancel Order
          </button>

        </div>
      </div>
    </main>
	)
}

function OrderDetailsSection({ heading, children }) {
	return (
		<section className="my-12">
			<h2 className="text-2xl text-center font-medium mb-4">{heading}</h2>
			{children}
		</section>
	)
}